import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GastosComponent } from './gastos.component';
import { GastosGuard } from './gastos.guard';

const routes: Routes = [
  {
    path: '',
    title: 'Gastos',
    component: GastosComponent,
    canActivate: [GastosGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GastosRoutingModule {}
